import { Button, makeStyles, Modal } from "@material-ui/core";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import CloseIcon from "@material-ui/icons/Close";
import { ReactComponent as DeleteIcon } from "assets/Delete.svg";
import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  body: {
    backgroundColor: theme.palette.background.paper,
    padding: "50px 32px 24px",

    width: "50vw",
    maxWidth: "775px",
    maxHeight: "365px",
    minHeight: "365px",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "center",
    borderRadius: "15px",
    position: "relative",

    "& .closeIcon": {
      position: "absolute",
      top: "10px",
      background: "#f1f1f2",
      insetInlineEnd: "10px",
      color: "#8d8d8d",
      borderRadius: "50px",
      display: "flex",
      padding: "10px",
      cursor: "pointer",
    },
    "& .title": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      "& .deleteIcon": {
        position: "relative",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        "& .bg": {
          display: "flex",
          background: "#f5dfdf",
          borderRadius: "50px",
          width: "fit-content",
          position: "absolute",
          padding: "25px",
          marginBottom: "35px",
          zIndex: 1,
        },
        "& svg": {
          width: "50px",
          height: "50px",
          color: "#bd292c",
          zIndex: 2,
        },
      },
    },
    "& .deleteTitle": {
      color: "#4C5157",
      fontSize: "20px",
    },
    "& .separator": {
      width: "100%",
      border: "1px solid #979797",
      opacity: "0.16",
    },
    "& .subtitle": {
      fontSize: "14px",
      fontWeight: "400",
      color: "#4C5157",
      "& span": { fontWeight: "bold" },
    },
    "& .actions": {
      display: "flex",
      gap: "23px",
      marginTop: "24px",
      "& button": {
        borderRadius: "20px",
        border: "1px solid #e7e7e7",
        width: "155px",
        height: "40px",
        fontSize: "12px",
      },
      "& .deleteBtn": {
        background: "#bd292c",
        color: "white",
      },
    },
  },
}));

interface DeleteModalProps {
  open: boolean;
  name: string;
  onClose: VoidFunction;
  onAccept: VoidFunction;
}

const DeleteModal: FunctionComponent<DeleteModalProps> = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={props.open}
        onClose={props.onClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={props.open}>
          <div className={classes.body}>
            <div className="closeIcon" onClick={props.onClose} aria-hidden>
              <CloseIcon />
            </div>
            <div className="title">
              <div className="deleteIcon">
                <DeleteIcon />
                <div className="bg" />
              </div>
              <h2 className="deleteTitle">{t("myStories.Delete dashboard")}</h2>
            </div>
            <div className="separator" />
            <h3 className="subtitle">
              {t("myStories.Delete permanently dashboard")}
              <span> {props.name}</span> ?
            </h3>
            <div className="separator" />
            <div className="actions">
              <Button className="cancelBtn" onClick={props.onClose} aria-hidden>
                {t("buttons.Cancel")}
              </Button>
              <Button
                className="deleteBtn"
                onClick={props.onAccept}
                aria-hidden
              >
                {t("buttons.Delete")}
              </Button>
            </div>
          </div>
        </Fade>
      </Modal>
    </div>
  );
};

export default DeleteModal;
